import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-modal" }
const _hoisted_2 = { class: "login-modal__header" }
const _hoisted_3 = { class: "login-modal__description" }
const _hoisted_4 = { class: "login-modal__button-container" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "login-modal__register-account-container" }
const _hoisted_7 = ["href"]

import dictionary from "@/i18n/dictionary.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressLoginModal',
  props: {
  loginUrl: {
    type: String,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t(_unref(dictionary).account.modalHeader)), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(_unref(dictionary).account.modalDescription)), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        href: __props.loginUrl,
        class: "login-modal__button"
      }, _toDisplayString(_ctx.$t(_unref(dictionary).account.login)), 9, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("a", {
        href: __props.loginUrl,
        class: "login-modal__register-account"
      }, _toDisplayString(_ctx.$t(_unref(dictionary).account.registerAccount)), 9, _hoisted_7)
    ])
  ]))
}
}

})